import { map, take } from 'rxjs/operators';
import { Route, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LoginRoutingGuard {
  constructor(private authService: AuthService, private router: Router) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {
    return this.authService.isAuthenticated$.pipe(
      map((bool) => {
        if (!bool) {
          // CURRENTLY canLoad has an issue: the route that is passed in, is missing all but the
          // root part of the route ie) /products
          // github link: https://github.com/angular/angular/issues/17359
          this.router.navigate(['/login'], { queryParamsHandling: 'preserve' });
          return true;
        } else {
          return true;
        }
      }),
      take(1),
    );
  }
}
